import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonFunctions } from '@shared/common-functions';
import { SharedInvoicePopupComponent } from '@shared/components/shared-invoice-popup/shared-invoice-popup.component';
import { DialogControlService } from '@shared/services/dialog-control.service';

@Component({
  selector: 'app-payments-detail',
  templateUrl: './payments-detail.component.html',
  styleUrls: ['./payments-detail.component.scss']
})
export class PaymentsDetailComponent {
  @Input() paymentList;
  @Input() itemsPerPage: number;
  @Input() paymentCurrentSkip: number;
  @Input() totalPaymentRecords: number;
  @Output() pageChangePaymentList = new EventEmitter<any>();
  @Output() viewInvoice = new EventEmitter<any>();
  @Output() sendInvoiceOnMail = new EventEmitter<any>();
  @Output() openInvoice = new EventEmitter<any>();
  items: any;

  constructor(private readonly dialogControlService: DialogControlService,
  ) { }

  showData(product: any) {
    const actionMap = {
      viewInvoice: () => {
        this.viewInvoice.emit(product.bookingId)
      },
      sendInvoiceOnMail: () => {
        this.sendInvoiceOnMail.emit(product.bookingId)
      },
      openInvoice: () => {
        this.openInvoice.emit(product);
      }
    }
    this.items = [
      {
        items: [
          {
            label: '',
            icon: '',
          },
          {
            label: 'View Invoice',
            icon: 'common-icon view-profile',
            escape: false,
            command: actionMap.viewInvoice,
          },
          {
            label: 'Share Invoice',
            icon: 'common-icon share-invoice',
            escape: false,
            command: () => {
              this.dialogControlService.openDialog(SharedInvoicePopupComponent, {
                styleClass: 'shareinvoice-model',
                data: {
                  bookingId: product.bookingId,
                  email: product?.driverEmail,
                  mobileNumber: product?.phoneNumber ? product?.countryCode + ' ' + product?.phoneNumber : null,
                  isBookingExist: true
                },
              });
            },
          },
          {
            label: 'Booking Summary',
            icon: 'pi pi-book',
            escape: false,
            command: actionMap.openInvoice,
          },
        ]
      },
    ];
  }
  onPagePaymentList(event) {
    this.pageChangePaymentList.emit(event);
  }
  getTimeZoneAbbreviation(timeZone: string): string {
    return CommonFunctions.getTimeZoneAbbreviation(timeZone);
  }
}
